import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentStatusForBatch } from '@edtech-ui/constants/student.status.enum';
import { GetBatchDetailsData } from '@edtech-ui/core/models/admin-panel/batch-management/batch-detail-page';
import { UserDetailResponse } from '@edtech-ui/core/models/Classroom/user-detail';
import { AdminService } from '@edtech-ui/core/services/admin-dashboard/admin.service';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { BatchManagementService } from '@edtech-ui/core/services/batch-management/batch-management.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-students-stats',
	standalone: true,
	imports: [CommonModule,
		FormsModule,
		MatButtonModule,
		MatCardModule,
		MatIconModule,
		MatChipsModule, MatProgressSpinnerModule,MatTooltipModule
	],
	templateUrl: './students-stats.component.html',
	styleUrl: './students-stats.component.scss'
})
export class StudentsStatsComponent implements OnInit, OnDestroy {

	adminEmail = '';
	batches: GetBatchDetailsData | null = null;
	batchId!: number;
	isLoading = false;
	subscription = new Subscription();
	studentStatusForBatch =StudentStatusForBatch;
	userDetail: UserDetailResponse['Data'] | null = null;
	userId='';

	constructor(private router: Router,
		private route: ActivatedRoute,
		private _batchService: BatchManagementService,
		private _toastr: ToastrService,
		private _adminService: AdminService,
		private _authService:AuthServiceService,

	) { }

	ngOnInit(): void {
		const batchId = this.route.snapshot.paramMap.get('batchId');
		if (batchId) {
			this.batchId = +batchId;
			this.getBetchById();
		}
		const storedId = localStorage.getItem('user_id');
		if (storedId) {
			this.userId = storedId;
			this.getUserDetails(this.userId);
		}
	}

	getBetchById() {
		this.isLoading = true;
		this.subscription.add(
			this._batchService.getBatchDetailsById(this.batchId).pipe(
				tap(response => {
					if (response.Success) {
						this.batches = response.Data;
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong.Please try again');
					return of(null);
				})
			).subscribe()
		);
	}

	goBack() {
		this.router.navigate(['/admin-dashboard/batch-management-landing']);
	}


	deleteUserById(userId: string) {
		this._adminService.deleteUserById(userId).pipe(
			tap(response => {
				if (response.Success) {
					this._toastr.success(response.Message);
					this.getBetchById();
				} else {
					this._toastr.error(response.Message);
				}
			}),
			catchError(() => {
				this._toastr.error('Something went wrong.Please try again');
				return of(null);
			})
		).subscribe();
	}

		getUserDetails(id: string) {
			this.isLoading = true;
			this.subscription.add(
				this._authService.getUserDetails(id).pipe(
					finalize(()=>{
						this.isLoading=false
					})
				).subscribe({
					next: (response: UserDetailResponse) => {
						if (response.Success) {
							this.userDetail = response.Data;
						}
					},
					error: () => this._toastr.error('Something went wrong while fecthing the user Details')
				})
			);
		}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
